import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive({
  selector: '[documentUploadDialogDirective]',
  standalone: false
})
export class DocumentUploadDialogDirective {
  viewContainerRef = inject(ViewContainerRef);
}
